import { useState, useRef, useEffect } from 'react'

import cn from 'classnames'

import { debounce } from '../../../utils/debounce'

import { Slide } from './components/slide'

import ArrowNext from './icons/arrowNext.svg'
import ArrowPrev from './icons/arrowPrevios.svg'

import ArrowNextVip from './icons/arrowNextVip.svg'
import ArrowPrevVip from './icons/arrowPreviousVip.svg'

import styles from './styles.module.scss'

import { ExchangeCommunityProps } from './exchange-community.props'

export default function ExchangeCommunity({ slides, isVipPage }: ExchangeCommunityProps) {
  const [dotPosition, setDotPosition] = useState(0)
  const [screenWidth, setScreenWidth] = useState<number>(0)

  const startX = useRef(-1)
  const startY = useRef(-1)

  const dots = []
  const dotsCages = []

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setScreenWidth(window.innerWidth)
    }
  }, [])

  const slideTo = (i: number): (() => void) => () => {
    setDotPosition(i)
  }

  for (let i = 0; i < slides.length; i++) {
    dots.push(
      <div key={i} className={cn(styles.dot, { [styles.dotEmpty]: !isVipPage }, { [styles.dot_vip]: isVipPage })} />,
    )
    dotsCages.push(<button className={styles.swiperDotCage} key={i} onClick={slideTo(i)} />)
  }

  const prevSlide = (): void => {
    setDotPosition((i) => {
      const newI = i - 1
      return newI >= 0 ? newI : slides.length - 1
    })
  }

  const nextSlide = (): void => {
    setDotPosition((i) => (i + 1) % slides.length)
  }

  const handleEnd = (): void => {
    startX.current = -1
    startY.current = -1
  }

  const margin = 10
  const moveUpdater = debounce((x, y) => {
    const diffY = startY.current - y
    if (Math.abs(diffY) > margin) {
      handleEnd()
      return
    }

    const diffX = startX.current - x
    if (diffX > margin) {
      nextSlide()
      handleEnd()
    } else if (diffX < -margin) {
      prevSlide()
      handleEnd()
    }
  }, 16.6)

  const handleTouchStart = (e: TouchEvent) => {
    startX.current = e.targetTouches[0].clientX
    startY.current = e.targetTouches[0].clientY
  }

  const handleTouchMove = (e: TouchEvent) => {
    const x = e.targetTouches[0].clientX
    if (startX.current > 0 && Math.abs(startX.current - x) > margin) {
      e.preventDefault()
      moveUpdater(x, e.targetTouches[0].clientY)
    }
  }

  const slidesRef = useRef<HTMLDivElement>()

  useEffect(() => {
    slidesRef.current.addEventListener('touchstart', handleTouchStart, { passive: true })
    slidesRef.current.addEventListener('touchmove', handleTouchMove, { passive: true })
    slidesRef.current.addEventListener('touchend', handleEnd, { passive: true })
    slidesRef.current.addEventListener('touchcancel', handleEnd, { passive: true })

    return () => {
      if (slidesRef.current) {
        slidesRef.current.removeEventListener('touchstart', handleTouchStart)
        slidesRef.current.removeEventListener('touchmove', handleTouchMove)
        slidesRef.current.removeEventListener('touchend', handleEnd)
        slidesRef.current.removeEventListener('touchcancel', handleEnd)
      }
    }
  }, [])

  useEffect(() => {
    if (window.Trustpilot) window.Trustpilot.loadFromElement(document.getElementsByClassName('trustpilot-widget')[0])
    if (typeof window !== 'undefined') {
      setScreenWidth(window.innerWidth)
    }
  }, [])

  return (
    <>
      <div className={cn(styles.swiperWrapper, { [styles.vip]: isVipPage })}>
        <div className={styles.swiperButton} onClick={prevSlide}>
          <img src={isVipPage ? ArrowPrevVip : ArrowPrev} alt="arrow prev" />
        </div>
        <div className={styles.swiperContent}>
          <div
            className={styles.slides}
            style={{
              left: `calc(-${
                isVipPage ? (screenWidth > 765 ? dotPosition * 103 : dotPosition * 105) : dotPosition * 100
              }%)`,
            }}
            ref={slidesRef}
          >
            {slides.map((item) => (
              // @ts-ignore
              <Slide key={item.id} {...item} />
            ))}
          </div>
          <div className={styles.dotsWrapper}>
            <div className={styles.dotsWrapperInner}>
              <div
                className={cn(styles.dot, { [styles.dotActiveVip]: isVipPage }, { [styles.dotActive]: !isVipPage })}
                style={{ left: dotPosition * 33 + 'px' }}
              />
              {dots}
              <div className={cn(styles.dotsCage, { [styles.vip]: isVipPage })}>{dotsCages}</div>
            </div>
          </div>
        </div>
        <div className={cn(styles.swiperButton, styles.swiperButtonNext)} onClick={nextSlide}>
          <img src={isVipPage ? ArrowNextVip : ArrowNext} alt="arrow next" />
        </div>
      </div>
    </>
  )
}
